export default {
    meta: {
        title: '线索编辑',
        isShowNav: true,
        activeMenu: '/clue',
    },
};
